import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { HttpExtendedService } from './http-extended.service';
import { NewsModel } from '../models/news';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  apiUrl: string;
  constructor(
    private http: HttpExtendedService,
    private config: ConfigService
  ) {
    this.apiUrl = config.config.newsUrl;
  }

  addNews(news: NewsModel): Observable<NewsModel> {
    const formData = new FormData();
    if (news.picture && news.picture.file) {
      formData.append('file', news.picture.file);
    }
    delete news.picture;
    formData.append('news', JSON.stringify(news));
    return this.http.post<NewsModel>(this.apiUrl, formData);
  }

  getNews(): Observable<NewsModel[]> {
    return this.http.get<NewsModel[]>(this.apiUrl).pipe(map(values => values.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())));
  }

  updateNews(news: NewsModel): Observable<NewsModel> {
    const formData = new FormData();
    if (news.picture && news.picture.file) {
      formData.append('file', news.picture.file);
    }
    delete news.picture;
    formData.append('news', JSON.stringify(news));
    return this.http.put<NewsModel>(this.apiUrl, formData);
  }

  deleteNews(news: NewsModel): Observable<NewsModel> {
    return this.http.post<NewsModel>(`${this.apiUrl}/delete`, news);
  }
}
